export const id = {
  title: 'PRODES (Amazon Hukum)',
  subtitle: 'tahunan, 6,25ha, Legal Amazon, INPE',
  content: [
    {
      label: 'Fungsi',
      value:
        'Sistem pemantauan deforestasi untuk Legal Amazon Brasil, yang digunakan oleh pemerintah Brasil untuk menetapkan kebijakan publik',
    },
    {
      label: 'Resolusi',
      value: '6,25ha',
    },
    {
      label: 'Cakupan geografis',
      value: 'Amazon Legal Brasil',
    },
    {
      label: 'Sumber',
      value: 'INPE',
    },
    {
      label: 'Frekuensi pembaruan',
      value: 'Setiap tahun',
    },
    {
      label: 'Tanggal konten',
      value: '2008-2021',
    },
    {
      label: 'Peringatan',
      value:
        'PRODES hanya mengidentifikasi pembukaan hutan seluas 6,25 hektar atau lebih, sehingga degradasi hutan atau pembukaan hutan dalam skala kecil akibat kebakaran atau penebangan selektif tidak terdeteksi. Seringnya tutupan awan di wilayah cakupannya dapat mengubah tahun terjadinya deforestasi yang dilaporkan. Tahun yang dilaporkan adalah tahun pertama deforestasi diidentifikasi oleh para analis, namun hal ini tidak selalu sesuai dengan tahun deforestasi jika lanskap tertutup awan pada tahun-tahun sebelumnya.',
    },
    {
      label: 'Lisensi',
      value: 'Creative Commons OLEH SA 3.0',
    },
  ],
  overview: {
    label: 'Ikhtisar',
    value:
      'Proyek PRODES memantau penebangan habis hutan di bioma Amazon Brazil dan Cerrado, dan telah menghasilkan laju deforestasi tahunan di wilayah tersebut sejak tahun 1988. Pemerintah Brazil menggunakan angka-angka ini untuk menetapkan kebijakan publik, termasuk menentukan akses terhadap kredit di bioma Amazon, menetapkan tujuan pengurangan deforestasi, dan mengumpulkan dana untuk mengurangi deforestasi. PRODES dulunya menggunakan citra Landsat 5, namun kini juga menggunakan citra Landsat 7 dan 8, CBERS-2, CBERS-2B, Resourcesat-1, dan UK2-DMC. PRODES dioperasikan oleh Institut Penelitian Luar Angkasa Nasional (INPE) bekerja sama dengan Kementerian Lingkungan Hidup (MMA) dan Institut Lingkungan Hidup dan Sumber Daya Alam Terbarukan Brasil (IBAMA). Sejak tahun 2002, semua data PRODES tersedia untuk umum secara online. Gambar masukan untuk masing-masing 220 jejak Landsat yang menutupi Amazon Brazil dan Cerrado dipilih berdasarkan kurangnya tutupan awan dan tanggal pengambilannya. Sistem PRODES menggunakan tahun musiman, yang dimulai pada tanggal 1 Agustus, untuk menghitung deforestasi tahunan, sehingga gambar dipilih sedekat mungkin dengan tanggal tersebut (umumnya dari bulan Juli, Agustus, dan September). Dari tahun 2003 hingga 2005, analis menggunakan transformasi gambar untuk menentukan komponen vegetasi, tanah, dan bayangan menggunakan program SPRING. Komponen-komponen tersebut disegmentasi dan dikelompokkan ke dalam kelas hutan, non-hutan, deforestasi pada tahun target, deforestasi sebelumnya, awan, dan air, yang kemudian diperbaiki secara manual oleh para ahli. Mulai tahun 2005, metodologi baru diterapkan yang menggunakan platform open source TerraAmazon. Platform ini memungkinkan analisis PRODES menjadi lebih seragam dan dapat menggabungkan citra dari berbagai satelit. Seperti sebelumnya, gambar dipilih sebisa mungkin bebas cloud. Gambar-gambar tersebut kemudian ditutup untuk mengecualikan non-hutan, deforestasi sebelumnya, dan air menggunakan analisis tahun sebelumnya. Analis kemudian menggambarkan poligon yang mengalami deforestasi di hutan utuh pada tahun sebelumnya. Kumpulan data ini menunjukkan deforestasi tahunan pada tahun 2008-2020 di Nrazilian Legal Amazon.',
  },
  citation: {
    label: 'Rujukan',
    value:
      "Institut Penelitian Luar Angkasa Nasional (INPE). 'PRODES deforestasi.' Diakses melalui Global Forest Watch pada [tanggal]. www.globalforestwatch.org",
  },
};
